import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner'

import { Cookbook } from './components/Cookbook'
import { RequireAuth } from './components/RequireAuth'
import History from './pages/History'
import Invite from './pages/Invite'
import Join from './pages/Join'
import Login from './pages/Login'
import LoginEmail from './pages/LoginEmail'
import NotFound from './pages/NotFound'
import Onboarding from './pages/Onboarding'
import ResetPassword from './pages/ResetPassword'
import Start from './pages/Start'
import Privacy from './pages/Privacy'
import RootLanding from './pages/RootLanding'
import Welcome from './pages/Welcome'
import AccountSettings from './pages/settings/AccountSettings'
import CogoSettings from './pages/settings/CogoSettings'
import CogoProductMapDetailSettings from './pages/settings/CogoProductMapDetailSettings'
import CogoProductsSettings from './pages/settings/CogoProductsSettings'
import EmailSettings from './pages/settings/EmailSettings'
import HouseholdSettings from './pages/settings/HouseholdSettings'
import InviteDetailSettings from './pages/settings/InviteDetailSettings'
import InvitesSettings from './pages/settings/InvitesSettings'
import ListDetailSettings from './pages/settings/ListDetailSettings'
import ListsSettings from './pages/settings/ListsSettings'
import PasswordSettings from './pages/settings/PasswordSettings'
import SettingsHome from './pages/settings/SettingsHome'
import SettingsLayout from './pages/settings/SettingsLayout'
import Home from './pg/Home'
import './index.css'

export function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" richColors closeButton position="top-center" />
      <Routes>
        <Route path="/start" element={<Start />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login/email" element={<LoginEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/join" element={<Join />} />
        <Route path="/invite/:code" element={<Invite />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/" element={<RootLanding />} />
        <Route path="/recipes" element={<Cookbook />} />
        <Route
          path="/planning"
          element={
            <RequireAuth>
              <Home />
            </RequireAuth>
          }
        />
        <Route
          path="/history"
          element={
            <RequireAuth>
              <History />
            </RequireAuth>
          }
        />
        <Route
          path="/settings"
          element={
            <RequireAuth>
              <SettingsLayout />
            </RequireAuth>
          }
        >
          <Route index element={<SettingsHome />} />
          <Route path="account" element={<AccountSettings />} />
          <Route path="account/email" element={<EmailSettings />} />
          <Route path="account/password" element={<PasswordSettings />} />
          <Route path="household" element={<HouseholdSettings />} />
          <Route path="cogo" element={<CogoSettings />} />
          <Route path="cogo/products" element={<CogoProductsSettings />} />
          <Route
            path="cogo/products/:productId"
            element={<CogoProductMapDetailSettings />}
          />
          <Route path="collect-and-go" element={<CogoSettings />} />
          <Route path="lists" element={<ListsSettings />} />
          <Route path="lists/:id" element={<ListDetailSettings />} />
          <Route path="invites" element={<InvitesSettings />} />
          <Route path="invites/:id" element={<InviteDetailSettings />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
